// ============================================================================
// This file is PROJECT SPECIFIC
// ============================================================================

// Registration member types
const initMemberTypes = () => {
  const countrySelect = document.getElementById('user_country')
  const memberTypeSelect = document.getElementById('user_member_type_id')

  if (!countrySelect || !memberTypeSelect) return

  const isLocked = countrySelect.disabled
  const memberTypes = JSON.parse(memberTypeSelect.dataset.memberTypes || '{}')

  const updateMemberTypeOptions = () => {
    const selectedCountryCode = countrySelect.value
    const desiredValue = memberTypeSelect.dataset.selectedValue || memberTypeSelect.value

    memberTypeSelect.innerHTML = '<option value="">Please Select</option>'

    if (!selectedCountryCode) {
      memberTypeSelect.disabled = true
      memberTypeSelect.value = ''
      memberTypeSelect.dataset.selectedValue = ''
      memberTypeSelect.dispatchEvent(new Event('change'))
      return
    }

    Object.entries(memberTypes).forEach(([memberTypeName, memberTypeData]) => {
      const { id, country_rule, countries = [] } = memberTypeData
      let shouldShow = false

      switch (country_rule) {
        case 'all_countries':
          shouldShow = true
          break
        case 'specific_countries':
          shouldShow = countries.includes(selectedCountryCode)
          break
        case 'exclude_countries':
          shouldShow = !countries.includes(selectedCountryCode)
          break
      }

      if (!shouldShow) return

      const option = document.createElement('option')
      option.value = id
      option.textContent = memberTypeName
      memberTypeSelect.appendChild(option)
    })

    if (
      Array.from(memberTypeSelect.options).some((option) => option.value === String(desiredValue))
    ) {
      memberTypeSelect.value = desiredValue
    } else {
      memberTypeSelect.value = ''
    }

    memberTypeSelect.disabled = isLocked || memberTypeSelect.options.length <= 1
    memberTypeSelect.dataset.selectedValue = ''
    memberTypeSelect.dispatchEvent(new Event('change'))
  }

  countrySelect.addEventListener('change', updateMemberTypeOptions)
  updateMemberTypeOptions()
}

// Show a field only for some answers to another field. The wrapper's
// data-show-when-field names the controlling field (e.g. "user[country]") and
// data-show-when-values lists the answers that show it; with
// data-show-when-except="true" it shows for any other answer instead. Inputs in
// a hidden wrapper are disabled so they aren't submitted, and inputs marked
// data-required-when-shown are required while shown.
const initConditionalFields = () => {
  document.querySelectorAll('[data-show-when-field]').forEach((wrapper) => {
    const source = wrapper.closest('form')?.elements.namedItem(wrapper.dataset.showWhenField)
    if (!source) return

    const values = JSON.parse(wrapper.dataset.showWhenValues || '[]')
    const except = wrapper.dataset.showWhenExcept === 'true'
    const inputs = Array.from(wrapper.querySelectorAll('input, select, textarea'))
    // A radio group comes back as a RadioNodeList whose value is the checked radio's
    const sources = source instanceof RadioNodeList ? Array.from(source) : [source]

    const update = () => {
      const value = source.value || ''
      const shown = value !== '' && values.includes(value) !== except

      wrapper.hidden = !shown
      inputs.forEach((input) => {
        input.disabled = !shown
        if ('requiredWhenShown' in input.dataset) input.required = shown
      })
    }

    sources.forEach((element) => element.addEventListener('change', update))
    update()
  })
}

// Initialize all custom functionality
const initRegistration = () => {
  initMemberTypes()
  initConditionalFields()
}

export default initRegistration
